module.exports = __webpack_public_path__ + "img/Ident-Process-4-mobile.d33000fe.png";